module.exports = __webpack_public_path__ + "img/portfolio-05.fb23ce26.jpg";